// Libraries
import moment from 'moment-timezone'
import I18n from 'i18next'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { message, Modal, Tag, Tooltip, Select } from 'antd'
import {
  get,
  map,
  includes,
  defaultTo,
  isNil,
  filter,
  toNumber,
  forEach,
  reject
} from 'lodash'

// Ressources
import { actions as scenarioActions } from 'Resources/ScenarioResource'
import { actions as siteActions } from 'Resources/SiteResource'
import { actions as siloActions } from 'Resources/SiloResource'
import { actions as basinActions } from 'Resources/BasinResource'
import { actions as tankActions } from 'Resources/TankResource'

// Common components
import { TableLayout, ManageModal } from 'Components'

// Styles
import './ScenariosScreen.less'

const { confirm } = Modal
const { Option } = Select

class ScenariosScreen extends Component {
  static propTypes = {
    // Actions d'API
    actions: PropTypes.object,

    // DonnÃ©es de la vue
    scenario: PropTypes.object,
    scenarios: PropTypes.array,
    sites: PropTypes.array,
    silos: PropTypes.array,
    basins: PropTypes.array,
    tanks: PropTypes.array,

    // TÃ©moin d'activitÃ© API
    isGathering: PropTypes.bool,
    isUpdating: PropTypes.bool,
    isCreating: PropTypes.bool,

    // Structure du tableLayout
    table: PropTypes.object,

    // Structure de la manageModal
    manageModal: PropTypes.object,

    // Navigation interne
    navigation: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
      getParam: PropTypes.func.isRequired
    })
  }

  static defaultProps = {
    // Actions d'API
    actions: {},

    // DonnÃ©es de la vue
    scenario: {},
    scenarios: [],
    sites: [],
    silos: [],
    basins: [],
    tanks: [],

    // TÃ©moin d'activitÃ© API
    isGathering: false,
    isUpdating: false,
    isCreating: false,

    // Structure du tableLayout
    table: {
      // Actions groupÃ©es
      actions: {
        global: {
          create: {
            label: 'common.create',
            icon: 'plus'
          }
        },
        selection: {
          // archive: {
          //   buttonType: 'danger'
          // },
          // update: {
          //   buttonType: 'primary'
          // },
          close: {
            buttonType: 'danger'
          },
          delete: {
            buttonType: 'danger'
          }
        }
      },

      // Gestion de l'internationalisation
      locale: {
        emptyText: 'pages.scenarios.table.empty'
      },

      // Gestion de la pagination
      pagination: {
        position: 'both',
        showSizeChanger: true,
        pageSizeOptions: ['10', '25', '50', '100']
      },

      // Identifiant unique de chaque ligne du tableau
      rowKey: 'id',

      // Colonnes du tableau
      columns: {
        name: {
          title: 'pages.basins.table.columns.name.title',
          dataIndex: 'name',
          key: 'name',
          render: name => defaultTo(name, I18n.t('common.none.male')),
          sorter: (a, b) =>
            defaultTo(get(a, 'name'), '').localeCompare(
              defaultTo(get(b, 'name'), '')
            )
        },
        startDate: {
          title: 'pages.scenarios.table.columns.startDate.title',
          dataIndex: 'startDate',
          key: 'startDate',
          render: date => (
            <Tooltip title={moment(date).format('LLLL')}>
              {moment(date).calendar()}
            </Tooltip>
          ),
          sorter: (a, b) =>
            moment(defaultTo(get(a, 'startDate'), 0)).valueOf() -
            moment(defaultTo(get(b, 'startDate'), 0)).valueOf(),
          defaultSortOrder: 'descend'
        },
        endDate: {
          title: 'pages.scenarios.table.columns.endDate.title',
          dataIndex: 'endDate',
          key: 'endDate',
          render: date => (
            <Tooltip title={moment(date).format('LLLL')}>
              {moment(date).calendar()}
            </Tooltip>
          ),
          sorter: (a, b) =>
            moment(defaultTo(get(a, 'endDate'), 0)).valueOf() -
            moment(defaultTo(get(b, 'endDate'), 0)).valueOf()
        },
        site: {
          title: 'pages.basins.table.columns.site.title',
          dataIndex: 'waterTank.site',
          key: 'site',
          render: site => (
            <Tag color={isNil(get(site, 'name')) ? 'orange' : 'lime'}>
              {defaultTo(get(site, 'name'), I18n.t('common.none.male'))}
            </Tag>
          ),
          sorter: (a, b) =>
            defaultTo(get(a, 'waterTank.site.name'), '').localeCompare(
              defaultTo(get(b, 'waterTank.site.name'), '')
            )
        },
        basin: {
          title: 'pages.scenarios.table.columns.basin.title',
          dataIndex: 'basin',
          key: 'basin',
          render: basin => (
            <Tag color={isNil(get(basin, 'name')) ? 'orange' : 'lime'}>
              {defaultTo(get(basin, 'name'), I18n.t('common.none.male'))}
            </Tag>
          ),
          sorter: (a, b) =>
            defaultTo(get(a, 'basin.name'), '').localeCompare(
              defaultTo(get(b, 'basin.name'), '')
            )
        },
        silo: {
          title: 'pages.scenarios.table.columns.silo.title',
          dataIndex: 'silo',
          key: 'silo',
          render: silo => (
            <Tag color={isNil(get(silo, 'name')) ? 'orange' : 'lime'}>
              {defaultTo(get(silo, 'name'), I18n.t('common.none.male'))}
            </Tag>
          ),
          sorter: (a, b) =>
            defaultTo(get(a, 'silo.name'), '').localeCompare(
              defaultTo(get(b, 'silo.name'), '')
            )
        }
      }
    },

    // Structure de la manageModal
    manageModal: {
      title: {
        update: 'pages.scenarios.modal.update.single.title',
        create: 'pages.scenarios.modal.create.single.title'
      },
      okText: {
        update: 'pages.scenarios.modal.update.single.okText',
        create: 'pages.scenarios.modal.create.single.okText'
      },
      steps: [
        {
          key: 'settings',
          title: 'pages.scenarios.modal.steps.settings.title'
        },
        {
          key: 'data',
          title: 'pages.scenarios.modal.steps.data.title'
        }
      ],
      actions: {
        close: {
          buttonType: 'danger'
        },
        delete: {
          buttonType: 'danger'
        }
      },
      rows: {
        // Ãtape paramÃ¨tres
        name: {
          title: 'pages.scenarios.modal.rows.name.title',
          dataIndex: 'name',
          key: 'name',
          formField: {
            visibility: {
              step: 'settings'
            },
            label: 'pages.scenarios.modal.rows.name.title',
            required: 'pages.scenarios.modal.rows.name.requiredMessage',
            placeholder: 'pages.scenarios.modal.rows.name.placeholder'
          }
        },
        startDate: {
          title: 'pages.scenarios.modal.rows.startDate.title',
          dataIndex: 'startDate',
          key: 'startDate',
          formField: {
            visibility: {
              step: 'settings'
            },
            type: 'datetime',
            initialValue: moment(),
            label: 'pages.scenarios.modal.rows.startDate.title',
            required: 'pages.scenarios.modal.rows.startDate.requiredMessage',
            placeholder: 'pages.scenarios.modal.rows.startDate.placeholder',
            format: date => moment(date)
          }
        },
        site: {
          title: 'pages.basins.modal.rows.site.title',
          dataIndex: 'site',
          key: 'site',
          formField: {
            visibility: {
              step: 'settings'
            },
            type: 'searchSelect',
            label: 'pages.basins.modal.rows.site.title',
            required: 'pages.silos.modal.rows.site.requiredMessage',
            placeholder: 'pages.basins.modal.rows.site.placeholder',
            format: site => get(site, 'id')
          }
        },
        target: {
          title: 'pages.scenarios.modal.rows.target.title',
          dataIndex: 'target',
          key: 'target',
          formField: {
            visibility: {
              step: 'settings',
              fieldsValues: {
                site: '[0-9]+'
              }
            },
            type: 'radios',
            label: 'pages.scenarios.modal.rows.target.title',
            required: 'pages.scenarios.modal.rows.target.requiredMessage',
            placeholder: 'pages.scenarios.modal.rows.target.placeholder'
          }
        },
        silo: {
          title: 'pages.scenarios.modal.rows.silo.title',
          dataIndex: 'silo',
          key: 'silo',
          formField: {
            visibility: {
              step: 'settings',
              fieldsValues: {
                target: 'silo'
              }
            },
            // Filtrage des options
            // Le site associÃ© au silo : `basin.site.id` doit correspondre Ã  la valeur de champs site
            filterOptions: {
              rules: {
                site: {
                  dataIndex: 'basin.site',
                  valueFromField: 'site'
                }
              }
            },
            type: 'searchSelect',
            label: 'pages.scenarios.modal.rows.silo.title',
            required: 'pages.scenarios.modal.rows.silo.requiredMessage',
            placeholder: 'pages.scenarios.modal.rows.silo.placeholder',
            questionMark: 'pages.scenarios.modal.rows.silo.questionMark',
            format: silo => get(silo, 'id')
          }
        },
        basin: {
          title: 'pages.scenarios.modal.rows.basin.title',
          dataIndex: 'basin',
          key: 'basin',
          formField: {
            visibility: {
              step: 'settings',
              fieldsValues: {
                target: 'basin'
              }
            },
            // Filtrage des options
            // Le site associÃ© au silo : `site.id` doit correspondre Ã  la valeur de champs site
            filterOptions: {
              rules: {
                site: {
                  dataIndex: 'site.id',
                  valueFromField: 'site'
                }
              }
            },
            type: 'searchSelect',
            label: 'pages.scenarios.modal.rows.basin.title',
            required: 'pages.scenarios.modal.rows.basin.requiredMessage',
            placeholder: 'pages.scenarios.modal.rows.basin.placeholder',
            questionMark: 'pages.scenarios.modal.rows.basin.questionMark',
            format: basin => get(basin, 'id')
          }
        },
        waterTank: {
          title: 'pages.scenarios.modal.rows.tank.water.title',
          dataIndex: 'waterTank',
          key: 'waterTank',
          formField: {
            visibility: {
              step: 'settings',
              fieldsValues: {
                site: '[0-9]+'
              }
            },
            // Filtrage des options
            // Le site associÃ© au silo : `site.id` doit correspondre Ã  la valeur de champs site
            filterOptions: {
              rules: {
                site: {
                  dataIndex: 'site.id',
                  valueFromField: 'site'
                }
              }
            },
            type: 'searchSelect',
            label: 'pages.scenarios.modal.rows.tank.water.title',
            required: 'pages.scenarios.modal.rows.tank.water.requiredMessage',
            placeholder: 'pages.scenarios.modal.rows.tank.water.placeholder',
            questionMark: 'pages.scenarios.modal.rows.tank.water.questionMark',
            format: tank => get(tank, 'id')
          }
        },
        emulsifierTank: {
          title: 'pages.scenarios.modal.rows.tank.water.title',
          dataIndex: 'emulsifierTank',
          key: 'emulsifierTank',
          formField: {
            visibility: {
              step: 'settings',
              fieldsValues: {
                site: '[0-9]+'
              }
            },
            // Filtrage des options
            // Le site associÃ© au silo : `site.id` doit correspondre Ã  la valeur de champs site
            filterOptions: {
              rules: {
                site: {
                  dataIndex: 'site.id',
                  valueFromField: 'site'
                }
              }
            },
            type: 'searchSelect',
            label: 'pages.scenarios.modal.rows.tank.emulsifier.title',
            required:
              'pages.scenarios.modal.rows.tank.emulsifier.requiredMessage',
            placeholder:
              'pages.scenarios.modal.rows.tank.emulsifier.placeholder',
            questionMark:
              'pages.scenarios.modal.rows.tank.emulsifier.questionMark',
            format: tank => get(tank, 'id')
          }
        },

        // Ãtape donnÃ©es utiles
        product: {
          title: 'pages.scenarios.modal.rows.product.title',
          dataIndex: 'product',
          key: 'product',
          formField: {
            visibility: {
              step: 'data',
              fieldsValues: {
                target: 'silo'
              }
            },
            label: 'pages.scenarios.modal.rows.product.title',
            placeholder: 'pages.scenarios.modal.rows.product.placeholder'
          }
        },
        applicationRate: {
          title: 'pages.scenarios.modal.rows.applicationRate.title',
          dataIndex: 'applicationRate',
          key: 'applicationRate',
          formField: {
            visibility: {
              step: 'data'
            },
            label: 'pages.scenarios.modal.rows.applicationRate.title',
            required:
              'pages.scenarios.modal.rows.applicationRate.requiredMessage',
            placeholder:
              'pages.scenarios.modal.rows.applicationRate.placeholder',
            questionMark:
              'pages.scenarios.modal.rows.applicationRate.questionMark',
            pattern: {
              pattern: '^(?=.)(([0-9]*)([\\.,]([0-9]+))?)$',
              transform: value => String(value),
              message:
                'pages.scenarios.modal.rows.applicationRate.patternMessage'
            },
            addonAfter: 'l/min/mÂ²',
            format: applicationRate =>
              !isNil(applicationRate) ? toNumber(applicationRate) : undefined
          }
        },
        waterFlow: {
          title: 'pages.scenarios.modal.rows.waterFlow.title',
          dataIndex: 'waterFlow',
          key: 'waterFlow',
          formField: {
            visibility: {
              step: 'data'
            },
            label: 'pages.scenarios.modal.rows.waterFlow.title',
            required: 'pages.scenarios.modal.rows.waterFlow.requiredMessage',
            placeholder: 'pages.scenarios.modal.rows.waterFlow.placeholder',
            questionMark: 'pages.scenarios.modal.rows.waterFlow.questionMark',
            pattern: {
              pattern:
                '^(0*[1-9][0-9]*([\\.,][0-9]+)?|0+[\\.,][0-9]*[1-9][0-9]*)$',
              transform: value => String(value),
              message: 'pages.scenarios.modal.rows.waterFlow.patternMessage'
            },
            addonAfter: 'mÂ³/h',
            format: waterFlow =>
              !isNil(waterFlow) ? toNumber(waterFlow) : undefined
          }
        },
        mixFlow: {
          title: 'pages.scenarios.modal.rows.mixFlow.title',
          dataIndex: 'mixFlow',
          key: 'mixFlow',
          formField: {
            visibility: {
              step: 'data'
            },
            label: 'pages.scenarios.modal.rows.mixFlow.title',
            required: 'pages.scenarios.modal.rows.mixFlow.requiredMessage',
            placeholder: 'pages.scenarios.modal.rows.mixFlow.placeholder',
            questionMark: 'pages.scenarios.modal.rows.mixFlow.questionMark',
            pattern: {
              pattern:
                '^(0*[1-9][0-9]*([\\.,][0-9]+)?|0+[\\.,][0-9]*[1-9][0-9]*)$',
              transform: value => String(value),
              message: 'pages.scenarios.modal.rows.mixFlow.patternMessage'
            },
            addonAfter: 'mÂ³/h',
            format: mixFlow => (!isNil(mixFlow) ? toNumber(mixFlow) : undefined)
          }
        },
        basinFlow: {
          title: 'pages.scenarios.modal.rows.basinFlow.title',
          dataIndex: 'basinFlow',
          key: 'basinFlow',
          formField: {
            visibility: {
              step: 'data'
            },
            label: 'pages.scenarios.modal.rows.basinFlow.title',
            required: 'pages.scenarios.modal.rows.basinFlow.requiredMessage',
            placeholder: 'pages.scenarios.modal.rows.basinFlow.placeholder',
            questionMark: 'pages.scenarios.modal.rows.basinFlow.questionMark',
            pattern: {
              pattern:
                '^(0*[1-9][0-9]*([\\.,][0-9]+)?|0+[\\.,][0-9]*[1-9][0-9]*)$',
              transform: value => String(value),
              message: 'pages.scenarios.modal.rows.basinFlow.patternMessage'
            },
            addonAfter: 'mÂ³/h',
            format: basinFlow =>
              !isNil(basinFlow) ? toNumber(basinFlow) : undefined
          }
        },
        emulsifierRate: {
          title: 'pages.scenarios.modal.rows.emulsifierRate.title',
          dataIndex: 'emulsifierRate',
          key: 'emulsifierRate',
          formField: {
            visibility: {
              step: 'data'
            },
            label: 'pages.scenarios.modal.rows.emulsifierRate.title',
            required:
              'pages.scenarios.modal.rows.emulsifierRate.requiredMessage',
            placeholder:
              'pages.scenarios.modal.rows.emulsifierRate.placeholder',
            questionMark:
              'pages.scenarios.modal.rows.emulsifierRate.questionMark',
            pattern: {
              pattern:
                '(^100([\\.,]0{1,2})?$)|(^([1-9]([0-9])?|0)([\\.,][0-9]{1,2})?$)',
              transform: value => String(value),
              message:
                'pages.scenarios.modal.rows.emulsifierRate.patternMessage'
            },
            addonAfter: '%',
            format: emulsifierRate =>
              !isNil(emulsifierRate) ? toNumber(emulsifierRate) : undefined
          }
        }
      }
    }
  }

  constructor(props) {
    super(props)

    this.state = {
      openedModal: null
    }
  }

  componentDidMount = () => {
    // RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
    this.fetchScenariosData()

    //  RÃ©cupÃ©ration des donnÃ©es des bacs pour association dans modale
    this.fetchSilosData()

    //  RÃ©cupÃ©ration des donnÃ©es des cuvettes pour association dans modale
    this.fetchBasinsData()

    // RÃ©cupÃ©ration des donnÃ©es des rÃ©servoirs pour association dans modale
    this.fetchTanksData()

    // RÃ©cupÃ©ration des donnÃ©es des sites pour association dans modale
    this.fetchSitesData()
  }

  componentDidUpdate = oldProps => {
    const status = this.props.navigation.getParam('status')

    if (oldProps.navigation.getParam('status') !== status) {
      this.fetchScenariosData()
    }
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des Ã©lÃ©ments de la vue
   */
  fetchScenariosData = () => {
    const status = this.props.navigation.getParam('status')

    // this.props.actions.fetchScenarios(null, { query: { status } }).catch(() => {
    this.props.actions.fetchScenarios({ status }).catch(() => {
      message.error(I18n.t('api.errors.scenario.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des sites pour association dans modale
   */
  fetchSitesData = () => {
    this.props.actions.fetchSites().catch(() => {
      message.error(I18n.t('api.errors.site.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des bacs pour association dans modale
   */
  fetchSilosData = () => {
    this.props.actions.fetchSilos().catch(() => {
      message.error(I18n.t('api.errors.silo.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des rÃ©servoirs pour association dans modale
   */
  fetchTanksData = () => {
    this.props.actions.fetchTanks().catch(() => {
      message.error(I18n.t('api.errors.tank.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es des cuvettes pour association dans modale
   */
  fetchBasinsData = () => {
    this.props.actions.fetchBasins().catch(() => {
      message.error(I18n.t('api.errors.basin.fetch'))
    })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es dÃ©taillÃ©es d'un Ã©lÃ©ment de la vue
   */
  getScenarioData = scenario =>
    new Promise((resolve, reject) => {
      this.props.actions
        .getScenario(scenario)
        .then(response => {
          // DÃ©tails rÃ©cupÃ©rÃ©s
          resolve(get(response, 'body'), response)
        })
        .catch(error => {
          // Erreur lors du refresh
          reject(error)
          message.error(I18n.t('api.errors.scenario.get'))
        })
    })

  /**
   * Actions groupÃ©e:
   * Archivage de plusieurs lignes du tableau
   */
  archiveScenarios = (scenarios, clearTableSelections) => {
    this.props.actions
      .archiveScenarios(scenarios)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.scenario.bulk.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scenario.bulk.archive'))
      })
  }

  /**
   * Archivage d'une ligne du tableau
   */
  archiveScenario = scenario => {
    this.props.actions
      .archiveScenario(scenario)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.scenario.archive'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scenario.archive'))
      })
  }

  /**
   * Actions groupÃ©e:
   * Suppression de plusieurs lignes du tableau
   */
  deleteScenarios = (scenarios, clearTableSelections) => {
    this.props.actions
      .deleteScenarios(scenarios)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.scenario.bulk.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scenario.bulk.delete'))
      })
  }

  /**
   * Suppression d'une ligne du tableau
   */
  deleteScenario = scenario => {
    this.props.actions
      .deleteScenario(scenario)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.scenario.delete'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scenario.delete'))
      })
  }

  /**
   * Actions groupÃ©e:
   * ClÃ´ture de plusieurs lignes du tableau
   */
  closeScenarios = (scenarios, clearTableSelections) => {
    this.props.actions
      .closeScenarios(scenarios)
      .then(() => {
        clearTableSelections()
        message.success(I18n.t('api.success.scenario.bulk.close'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scenario.bulk.close'))
      })
  }

  /**
   * ClÃ´ture d'une ligne du tableau
   */
  closeScenario = scenario => {
    this.props.actions
      .closeScenario(scenario)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.scenario.close'))
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scenario.close'))
      })
  }

  /**
   * Conversion d'une unit de volume temps Ã  une autre
   */
  convertFlowUnit = (value, unit, wantedUnit = 'm3h') => {
    let result = toNumber(value)

    if (wantedUnit === 'm3h') {
      // UnitÃ© source: m3/h
      // Conversion en litre par minute
      if (unit === 'lmin') {
        // Conversion en litre par heure
        result /= 1000
        // Conversion en litre par minute
        result *= 60
      }
    } else if (wantedUnit === 'lmin') {
      // UnitÃ© source: L/min
      // Conversion en mÃ¨tre cube par heure
      if (unit === 'm3h') {
        // Conversion en mÃ¨tre cube par minutes
        result *= 1000
        // Conversion en mÃ¨tre cube par heure
        result /= 60
      }
    }

    return result
  }

  /**
   * Mise Ã  jour d'un scenario
   */
  updateScenario = (updatedScenario, originalScenario) =>
    new Promise((resolve, reject) => {
      const { selectedFlowFieldsUnit } = this.state

      // Pour chaque champs de flux, conversion de la valeur en m3/h quelque que soit l'unitÃ© choisie
      forEach(selectedFlowFieldsUnit, (unit, field) => {
        updatedScenario[field] = this.convertFlowUnit(
          updatedScenario[field],
          unit
        )
      })

      this.setState({
        selectedFlowFieldsUnit: {}
      })

      this.props.actions
        .updateScenario({ id: get(originalScenario, 'id'), ...updatedScenario })
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.scenario.update'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.scenario.update'))
        })
    })

  /**
   * CrÃ©ation d'un scenario
   */
  createScenario = createdScenario =>
    new Promise((resolve, reject) => {
      const { selectedFlowFieldsUnit } = this.state

      // Pour chaque champs de flux, conversion de la valeur en m3/h quelque que soit l'unitÃ© choisie
      forEach(selectedFlowFieldsUnit, (unit, field) => {
        createdScenario[field] = this.convertFlowUnit(
          createdScenario[field],
          unit
        )
      })

      this.setState({
        selectedFlowFieldsUnit: {}
      })

      // Mapping pour API
      createdScenario.basin = defaultTo(get(createdScenario, 'basin'), null)
      createdScenario.silo = defaultTo(get(createdScenario, 'silo'), null)

            // todo: rustine +2h
            createdScenario.startDate = defaultTo(createdScenario.startDate, moment())
            createdScenario.startDate.add(2, 'hours')


      this.props.actions
        .createScenario({ ...createdScenario, status: 'running' })
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.scenario.create'))
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.scenario.create'))
        })
    })

  /**
   * Actions groupÃ©e:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askArchiveScenarios = (...params) => {
    confirm({
      title: I18n.t('pages.scenarios.modal.archive.multiple.title'),
      content: I18n.t('pages.scenarios.modal.archive.multiple.content'),
      okText: I18n.t('pages.scenarios.modal.archive.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scenarios.modal.archive.multiple.cancelText'),
      onOk: () => {
        this.archiveScenarios(...params)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askArchiveScenario = () => {
    const scenario = get(this.props, 'scenario')

    confirm({
      title: I18n.t('pages.scenarios.modal.archive.single.title'),
      content: I18n.t('pages.scenarios.modal.archive.single.content'),
      okText: I18n.t('pages.scenarios.modal.archive.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scenarios.modal.archive.single.cancelText'),
      onOk: () => {
        this.archiveScenario(scenario)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Actions groupÃ©e:
   * Demande d'archivage de plusieurs lignes du tableau
   */
  askDeleteScenarios = (...params) => {
    confirm({
      title: I18n.t('pages.scenarios.modal.delete.multiple.title'),
      content: I18n.t('pages.scenarios.modal.delete.multiple.content'),
      okText: I18n.t('pages.scenarios.modal.delete.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scenarios.modal.delete.multiple.cancelText'),
      onOk: () => {
        this.deleteScenarios(...params)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Actions groupÃ©e:
   * Demande de clÃ´ture de plusieurs lignes du tableau
   */
  askCloseScenarios = (...params) => {
    confirm({
      title: I18n.t('pages.scenarios.modal.close.multiple.title'),
      content: I18n.t('pages.scenarios.modal.close.multiple.content'),
      okText: I18n.t('pages.scenarios.modal.close.multiple.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scenarios.modal.close.multiple.cancelText'),
      onOk: () => {
        this.closeScenarios(...params)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askDeleteScenario = () => {
    const scenario = get(this.props, 'scenario')

    confirm({
      title: I18n.t('pages.scenarios.modal.delete.single.title'),
      content: I18n.t('pages.scenarios.modal.delete.single.content'),
      okText: I18n.t('pages.scenarios.modal.delete.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scenarios.modal.delete.single.cancelText'),
      onOk: () => {
        this.deleteScenario(scenario)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Demande d'archivage d'une ligne du tableau
   */
  askCloseScenario = () => {
    const scenario = get(this.props, 'scenario')

    confirm({
      title: I18n.t('pages.scenarios.modal.close.single.title'),
      content: I18n.t('pages.scenarios.modal.close.single.content'),
      okText: I18n.t('pages.scenarios.modal.close.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scenarios.modal.close.single.cancelText'),
      onOk: () => {
        this.closeScenario(scenario)
      },
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Ouverture de la modale de modifications
   */
  openModal = (creating = true) => {
    this.setState({
      openedModal: creating ? 'createScenario' : 'updateScenario',
      selectedFlowFieldsUnit: {}
    })
  }

  /**
   * Fermeture de toutes les modales
   */
  handleCloseModal = () => {
    const { openedModal } = this.state

    if (openedModal === 'updateEvent') {
      this.setState({ openedModal: 'transition' }, () => {
        setTimeout(
          this.setState({ openedModal: null, selectedFlowFieldsUnit: {} }),
          200
        )
      })
    } else {
      this.setState({ openedModal: null, selectedFlowFieldsUnit: {} })
    }
  }

  /**
   * Callback:
   * CrÃ©ation d'une ligne de tableau rÃ©ussie
   */
  handleScenarioCreated = () => {
    this.handleCloseModal()
  }

  /**
   * Clic sur une ligne du tableau
   */
  handleRowClick = scenario => {
    // this.getScenarioData(scenario)
    // this.setState({ openedModal: 'updateScenario' })

    this.props.navigation.navigate('Scenario', {
      id: get(scenario, 'id'),
      status: isNil(get(scenario, 'endDate')) ? 'running' : 'done'
    })
  }

  /**
   * Rendu du sÃ©lecteur d'unitÃ© de temps volume
   */
  renderSelectFlowUnit = input => {
    const onChange = (input, unit) => {
      // UnitÃ©s choisies pour chaque input
      this.setState(({ selectedFlowFieldsUnit = {} }) => {
        selectedFlowFieldsUnit[input] = defaultTo(unit, 'm3h')
        return { selectedFlowFieldsUnit }
      })
    }

    // SÃ©lecteur d'unitÃ©
    return (
      <Select
        value={defaultTo(
          get(this.state, `selectedFlowFieldsUnit[${input}]`),
          'm3h'
        )}
        defaultValue={defaultTo(
          get(this.state, `selectedFlowFieldsUnit[${input}]`),
          'm3h'
        )}
        onChange={unit => onChange(input, unit)}
        style={{ width: 80 }}
      >
        {map(['m3h', 'lmin'], unit => (
          <Option key={unit} value={unit}>
            {I18n.t(`common.units.${unit}`)}
          </Option>
        ))}
      </Select>
    )
  }

  render() {
    const {
      table,
      isGathering,
      manageModal,
      isUpdating,
      isCreating,
      scenarios,
      scenario,
      sites,
      silos,
      basins,
      tanks,
      navigation
    } = this.props
    const { openedModal } = this.state

    // GESTION DES TABLEAUX

    // Ajout des donnÃ©es au tableau
    table.rows =
      navigation.getParam('status') === 'done'
        ? reject(scenarios, { endDate: null })
        : filter(scenarios, { endDate: null })

    // Ajout des actions au clic sur un ligne du tableau
    table.onRow = (scenario, id) => ({
      onClick: () => this.handleRowClick(scenario, id)
    })

    // Ajout des actions multiples sur le tableau
    // table.actions.selection.archive.onClick = this.askArchiveScenarios
    // table.actions.selection.update.onClick = this.askUpdateScenarios
    table.actions.selection.close.onClick = this.askCloseScenarios
    table.actions.selection.delete.onClick = this.askDeleteScenarios

    table.actions.selection.close.hidden =
      navigation.getParam('status') === 'done'

    // Suppression de la colonne date de fin si le scÃ©nario n'est pas fini
    table.columns.endDate.hidden = navigation.getParam('status') === 'running'

    // GESTION DES BOUTONS

    // Ajout des actions des boutons
    table.actions.global.create.onClick = this.openModal
    table.actions.global.create.hidden =
      navigation.getParam('status') === 'done'

    // GESTION DE LA MODALE DE GESTION

    // Ajout des actions sur la modale
    manageModal.actions.close.onClick = this.askCloseScenario
    manageModal.actions.delete.onClick = this.askDeleteScenario

    manageModal.actions.close.hidden = navigation.getParam('status') === 'done'

    // Ajout des options pour le choix d'un site
    manageModal.rows.site.formField.options = map(sites, site => ({
      id: get(site, 'id'),
      label: get(site, 'name'),
      disabled: false,
      value: get(site, 'id'),
      data: site
    }))

    // Ajout des options pour le choix d'un bac
    manageModal.rows.silo.formField.options = map(silos, silo => ({
      id: get(silo, 'id'),
      label: get(silo, 'name'),
      disabled: false,
      value: get(silo, 'id'),
      data: silo
    }))

    // Ajout des options pour le choix d'une cuvette
    manageModal.rows.basin.formField.options = map(basins, basin => ({
      id: get(basin, 'id'),
      label: get(basin, 'name'),
      disabled: false,
      value: get(basin, 'id'),
      data: basin
    }))

    // Ajout des options pour le choix d'un rÃ©servoir d'Ã©mulseur
    manageModal.rows.target.formField.options = map(
      ['basin', 'silo'],
      target => ({
        label: I18n.t(`pages.scenarios.modal.rows.target.${target}`),
        value: target,
        data: target
      })
    )

    // Ajout des options pour le choix d'un rÃ©servoir d'eau
    manageModal.rows.waterTank.formField.options = map(
      filter(tanks, { element: 'WATER' }),
      tank => ({
        id: get(tank, 'id'),
        label: get(tank, 'name'),
        disabled: false,
        value: get(tank, 'id'),
        data: tank
      })
    )

    // Ajout des options pour le choix d'un rÃ©servoir d'Ã©mulseur
    manageModal.rows.emulsifierTank.formField.options = map(
      filter(tanks, { element: 'EMULSIFIER' }),
      tank => ({
        id: get(tank, 'id'),
        label: get(tank, 'name'),
        disabled: false,
        value: get(tank, 'id'),
        data: tank
      })
    )

    // Ajout du sÃ©lecteur d'unitÃ© (L/min ou m3/h) aux input de dÃ©bit
    forEach(['waterFlow', 'mixFlow', 'basinFlow'], input => {
      manageModal.rows[input].formField.addonAfter = this.renderSelectFlowUnit(
        input
      )
    })

    // GESTION DES LOADERS
    const loading = isGathering || isUpdating || isCreating

    return (
      <main className='screen scenarios'>
        {/* Affichage des donnÃ©es de la page */}
        <TableLayout
          elementName='scenario'
          elementKind='male'
          elementConsonant
          loading={loading}
          {...table}
        />

        {/* Ouverture de la modale de crÃ©ation / modification */}
        <ManageModal
          width={720}
          loading={loading}
          onCancel={this.handleCloseModal}
          onOk={this.handleScenarioCreated}
          onChange={
            openedModal === 'updateScenario'
              ? this.updateScenario
              : this.createScenario
          }
          visible={includes(['createScenario', 'updateScenario'], openedModal)}
          data={
            includes(['transition', 'updateScenario'], openedModal)
              ? scenario
              : null
          }
          {...manageModal}
        />
      </main>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(ScenariosScreen, 'defaultProps', {})

  return {
    scenario: defaultTo(get(state, 'scenario.item'), defaultProps.scenario),
    scenarios: defaultTo(get(state, 'scenario.items'), defaultProps.scenarios),
    sites: defaultTo(get(state, 'site.items'), defaultProps.sites),
    silos: defaultTo(get(state, 'silo.items'), defaultProps.silos),
    basins: defaultTo(get(state, 'basin.items'), defaultProps.basins),
    tanks: defaultTo(get(state, 'tank.items'), defaultProps.tanks),
    isGathering:
      defaultTo(get(state, 'scenario.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'site.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'silo.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'basin.isFetching'), defaultProps.isGathering) ||
      defaultTo(get(state, 'tank.isFetching'), defaultProps.isGathering) ||
      defaultTo(
        get(state, 'scenario.isFetchingItem'),
        defaultProps.isGathering
      ),
    isUpdating: defaultTo(
      get(state, 'scenario.isUpdating'),
      defaultProps.isUpdating
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...scenarioActions,
      ...siteActions,
      ...siloActions,
      ...basinActions,
      ...tankActions
    },
    dispatch
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScenariosScreen)
